const API_URL = process.env.REACT_APP_API_URL;

export async function getCoresByModelo(modelo) {
  const url = `${API_URL}/cores?modelo=${encodeURIComponent(modelo)}`;

  try {
    const response = await fetch(url);

    if (!response.ok) throw new Error('Erro ao buscar cores');

    const data = await response.json();

    return data;
  } catch (error) {
    console.error('[Erro na API de cores]', error);
    return [];
  }
}
